import { useFormikContext } from "formik"
import React from "react"
import { findField } from "@app/utils/form"
import { useRouteLoaderData } from "react-router-dom"
import { compareMeasureLabels } from "@app/utils/helper"

function setSelectOption (selectField, options) {
	if (selectField) {
		if (!selectField.defaultOptions) {
			selectField.defaultOptions = [...(selectField.options || [])]
		}
		const additionalOptions = options
			.map((value) => value.trim())
			.sort(compareMeasureLabels)
			.map(value => ({
				value: value,
				label: value,
			})) || []
		selectField.options = [
			// ...selectField.defaultOptions,
			...additionalOptions,
		]
	}
}

export const useDangerMeasureObserver = (currentFieldsets) => {
	const { values } = useFormikContext()
	const { measuresCatalogue, measuresByInfluence } = useRouteLoaderData("root") || {}
	const defaultOptions = measuresCatalogue

	// set measure options in case of set influenceValue
	const influencesValue = values.physischegefaehrdungsanalyse_gefaehrdungstyp_einflussamtaetigkeitsort
	const influencesField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_einflussamtaetigkeitsort")

	let res = React.useMemo(() => {
		const isInfluence = influencesValue && influencesValue?.length > 0

		const psaFormGroup = findField(currentFieldsets, "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_psa")
		if (psaFormGroup?.formGroup) {
			const psaSelectField = findField([psaFormGroup.formGroup], "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_psa_titel")
			if (isInfluence) {
				const options = measuresByInfluence?.[influencesValue]?.PSA;
				setSelectOption(psaSelectField, options)
			} else {
				psaSelectField.options = defaultOptions.PSA
					.sort(compareMeasureLabels)
					.map(label => ({
						label: label,
						value: label,
					}))
			}
		}

		const preventionFormGroup = findField(currentFieldsets, "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_vorsorgen")
		if (preventionFormGroup?.formGroup) {
			const preventionSelectField = findField([preventionFormGroup.formGroup], "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_vorsorgen_titel")
			if (isInfluence) {
				const options = measuresByInfluence?.[influencesValue]?.Vorsorge;
				setSelectOption(preventionSelectField, options)
			} else {
				preventionSelectField.options = defaultOptions.Vorsorge
					.sort(compareMeasureLabels)
					.map(label => ({
						label: label,
						value: label,
					}))
			}
		}

		const preventionFormGroup2 = findField(currentFieldsets, "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_angebotsvorsorgen")
		if (preventionFormGroup2?.formGroup) {
			const preventionSelectField2 = findField([preventionFormGroup2.formGroup], "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_angebotsvorsorgen_titel")
			if (isInfluence) {
				const options = measuresByInfluence?.[influencesValue]?.Vorsorge;
				setSelectOption(preventionSelectField2, options)
			} else {
				preventionSelectField2.options = defaultOptions.Vorsorge
					.sort(compareMeasureLabels)
					.map(label => ({
						label: label,
						value: label,
					}))
			}
		}

		const instructionFormGroup = findField(currentFieldsets, "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_unterweisung")
		if (instructionFormGroup?.formGroup) {
			const instructionSelectField = findField([instructionFormGroup.formGroup], "physischegefaehrdungsanalyse_zusaetzlichemassnahmen_unterweisung_titel")
			if (isInfluence) {
				const options = measuresByInfluence?.[influencesValue]?.Unterweisung;
				setSelectOption(instructionSelectField, options)
			} else {
				instructionSelectField.options = defaultOptions.Unterweisung.map(label => ({
					label: label,
					value: label,
				}))
			}
		}

		return {
			fieldsets: currentFieldsets,
		}
	}, [influencesValue, currentFieldsets])

	return res
}
